import * as React from 'react'

import { LOCIZE_NAMESPACE } from 'main/common'
import { Networks, useWhitelabel } from 'main/framework'
import { i18nKeyPrefix } from 'main/pages/Search/i18n'
import { CrossIcon, Title } from 'main/ui'
import { AssetName } from 'main/util/asset'
import { IFilters, initializeFilters } from 'main/util/search'
import { useTranslation } from 'react-i18next'
import { AgeRangeFields } from '../../AgeRangeFilter'
import { AvailabilityFields } from '../../AvailabilityFilter'
import { BudgetFilterFields } from '../../BudgetFilter'
import { DaysPerWeekFields } from '../../DaysPerWeekFilter'
import { DropOffHoursFields } from '../../DropOffHoursFilter'
import { NetworkRatingFields } from '../../NetworkRatingFilter'
import { NetworkRatingFields as NetworkRatingFieldsV2 } from '../../NetworkRatingFilterV2'
import { PickUpHoursFields } from '../../PickUpHoursFilter'
import { ProgramOfferingsFields } from '../../ProgramOfferingsFilter'
import { ProgramTypeFields } from '../../ProgramTypeFilter'
import { SpokenLanguageFields } from '../../SpokenLanguageFilter'
import { ToursAndEventsFields } from '../../ToursAndEventsFilter'
import { ISearchFormProps } from '../../types'
import {
  ClearAllText,
  Container,
  ContentContainer,
  CrossIconContainer,
  FieldsContainer,
  HeaderContainer,
  ShowResultsContainer,
  ShowResultsText,
} from './FilterForm.styles'

const PRE = `${i18nKeyPrefix}-MOBILE-FILTER-FORM`

export default function FilterForm(props: ISearchFormProps) {
  const { filters, onChangeFilters, onRequestCloseForm } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  const [params, setParams] = React.useState<IFilters>({ ...filters })
  const whitelabel = useWhitelabel()
  const notUsingNewMexico = whitelabel.networkAbbr !== Networks.NM

  return (
    <Container>
      <HeaderContainer>
        <CrossIconContainer onClick={() => onRequestCloseForm()}>
          <CrossIcon />
        </CrossIconContainer>
        <Title kind="section">{t(`${PRE}-TITLE`)}</Title>
        <ClearAllText onClick={() => handleClearAll()}>{t(`${PRE}-CLEAR`)}</ClearAllText>
      </HeaderContainer>
      <ContentContainer>
        <FieldsContainer>
          <AgeRangeFields params={params} onChangeParams={setParams} />
          <AvailabilityFields params={params} onChangeParams={setParams} />
          <DaysPerWeekFields params={params} onChangeParams={setParams} />
          {notUsingNewMexico && (
            <>
              <DropOffHoursFields params={params} onChangeParams={setParams} />
              <PickUpHoursFields params={params} onChangeParams={setParams} />
            </>
          )}
          <ProgramTypeFields params={params} onChangeParams={setParams} />
          <BudgetFilterFields params={params} onChangeParams={setParams} />
          <ToursAndEventsFields params={params} onChangeParams={setParams} />
          {whitelabel.hideByDefaultExceptIfTrue(AssetName.NETWORK_RATING_FILTERS) && (
            <NetworkRatingFields params={params} onChangeParams={setParams} />
          )}
          {whitelabel.hideByDefaultExceptIfTrue(AssetName.NETWORK_RATING_FILTERS_V2) && (
            <NetworkRatingFieldsV2 params={params} onChangeParams={setParams} />
          )}
          <SpokenLanguageFields params={params} onChangeParams={setParams} />
          <ProgramOfferingsFields params={params} onChangeParams={setParams} />
        </FieldsContainer>
      </ContentContainer>
      <ShowResultsContainer onClick={() => handleShowResults()}>
        <ShowResultsText>{t(`${PRE}-SHOW`)}</ShowResultsText>
      </ShowResultsContainer>
    </Container>
  )

  function handleClearAll() {
    setParams(initializeFilters())
  }
  function handleShowResults() {
    onRequestCloseForm()
    onChangeFilters({ ...filters, ...params })
  }
}
